import React, { useEffect } from "react";
import styles from "./BridgingLoanBlog.module.scss";
import CallAdviser from "../../components/CallAdviser";
import NewsContainer from "../../components/NewsContainer";
import TestimonialsContainer from "../../components/TestimonialsContainer";
import Footer from "../../components/Footer";
import CompareContainerB6 from "../../components/CompareContainer/CompareContainerB6";
import MatchingMortgagesB6 from "../../components/MatchingMortgages/MatchingMortgagesB6";
import LoanApplication from "../../components/LoanApplication/LoanApplication";
import HeroSection from "../../components/HeroSection/HeroSection";
const BridgingLoanBlog6 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.bridgingLoanBlog}>
      <HeroSection title="Bridging Loans" />
      <CompareContainerB6 title="Bridging Loans" />
      <CallAdviser title="Bridging Loans" />
      <MatchingMortgagesB6 title="Bridging Loans" />
      <NewsContainer title="Bridging Loans" />
      <LoanApplication title="Bridging Loans" />
      <TestimonialsContainer title="Bridging Loans" />
      <Footer title="Bridging Loans" />
    </div>
  );
};

export default BridgingLoanBlog6;
